// utils/youtube.js

export const getYouTubeId = (url) => {
  if (!url) return null;

  const regExp =
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^?&]+)/;

  const match = url.match(regExp);
  return match ? match[1] : null;
};
